<template>
  <div class="all">
    <div class="block" v-for="item in NavList" :key="item.id">
      <SelfTips :title="item.title" />
      <div class="items">
        <div
          class="item"
          v-for="each in item.children"
          :key="each.id"
          @click="routerPush(each)"
          @mouseenter="mouseIn(each)"
          @mouseleave="mouseOut(each)"
        >
          <img :src="each.hover ? each.active : each.src" />
          <p>{{ each.title }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CheckLogin } from "@/api/login";
import { GetNotice } from "@/api/public";
export default {
  name: "home",
  data() {
    return {
      NavList: [
        {
          id: 4,
          title: "查询业务",
          children: [
            {
              id: 40,
              title: "历史账单查询",
              path: "/seahistory",
              hover: false,
              src: require("../assets/img/icon/search/1.png"),
              active: require("../assets/img/icon/search/1-active.png"),
            },
            {
              id: 41,
              ywid: 13,
              title: "水费查询",
              path: "/seawater",
              hover: false,
              src: require("../assets/img/icon/search/2.png"),
              active: require("../assets/img/icon/search/2-active.png"),
            },
            {
              id: 42,
              ywid: 14,
              title: "缴费记录查询",
              path: "/searchrecord",
              hover: false,
              src: require("../assets/img/icon/search/3.png"),
              active: require("../assets/img/icon/search/3-active.png"),
            },
            {
              id: 43,
              ywid: "",
              title: "电子发票",
              path: "/invoice",
              hover: false,
              src: require("../assets/img/icon/search/4.png"),
              active: require("../assets/img/icon/search/4-active.png"),
            },
            {
              id: 44,
              ywid: "",
              title: "用户绑定",
              path: "/userbinding",
              hover: false,
              src: require("../assets/img/icon/search/5.png"),
              active: require("../assets/img/icon/search/5-active.png"),
            },
            {
              id: 45,
              ywid: "",
              title: "业务办理查询",
              path: "/seabusiness",
              hover: false,
              src: require("../assets/img/icon/search/6.png"),
              active: require("../assets/img/icon/search/6-active.png"),
            },
          ],
        },
        {
          id: 1,
          title: "供水报装",
          children: [
            {
              id: 10,
              ywid: 1,
              title: "居民用户报装",
              path: "/userpacking",
              meta: {
                has: true,
                path: "YwJmbz",
              },
              hover: false,
              src: require("../assets/img/icon/packing/1.png"),
              active: require("../assets/img/icon/packing/1-active.png"),
            },
            {
              id: 11,
              ywid: 2,
              title: "施工临时用水",
              path: "/construction",
              hover: false,
              meta: {
                has: true,
                path: "YwSglsysbz",
              },
              src: require("../assets/img/icon/packing/2.png"),
              active: require("../assets/img/icon/packing/2-active.png"),
            },
            {
              id: 12,
              ywid: 3,
              title: "新建项目报装",
              path: "/newproject",
              meta: {
                has: true,
                path: "YwXjxmbz",
              },
              hover: false,
              src: require("../assets/img/icon/packing/3.png"),
              active: require("../assets/img/icon/packing/3-active.png"),
            },
            {
              id: 19,
              ywid: 19,
              title: "小微企业用水报装",
              path: "/smallcompany",
              meta: {
                has: true,
                path: "YwXwqyysbz",
              },
              hover: false,
              src: require("../assets/img/icon/packing/4.png"),
              active: require("../assets/img/icon/packing/4-active.png"),
            },
            {
              id: 13,
              ywid: 4,
              title: "其他供水报装",
              path: "/otherpacking",
              meta: {
                has: true,
                path: "YwQtgsbz",
              },
              hover: false,
              src: require("../assets/img/icon/packing/5.png"),
              active: require("../assets/img/icon/packing/5-active.png"),
            },
          ],
        },
        {
          id: 2,
          title: "居民业务",
          children: [
            {
              id: 21,
              ywid: 1018,
              title: "合同新签",
              path: "/newcontract",
              meta: {
                has: true,
                path: "YwJmhtxq",
              },
              hover: false,
              src: require("../assets/img/icon/business/1.png"),
              active: require("../assets/img/icon/business/1-active.png"),
            },
            {
              id: 22,
              ywid: 11,
              title: "合同过户",
              path: "/contracttransfer",
              meta: {
                has: true,
                path: "YwJmgh",
              },
              hover: false,
              src: require("../assets/img/icon/business/2.png"),
              active: require("../assets/img/icon/business/2-active.png"),
            },
            {
              id: 23,
              ywid: 12,
              title: "用水人口变更",
              path: "/peoplechange",
              meta: {
                has: true,
                path: "YwJmysrkbg",
              },
              hover: false,
              src: require("../assets/img/icon/business/3.png"),
              active: require("../assets/img/icon/business/3-active.png"),
            },
            {
              id: 24,
              ywid: "",
              title: "暂停用水",
              path: "/usersuspend",
              meta: {
                has: true,
                path: "YwJmztys",
              },
              hover: false,
              src: require("../assets/img/icon/business/4.png"),
              active: require("../assets/img/icon/business/4-active.png"),
            },
            {
              id: 25,
              ywid: "",
              title: "恢复用水",
              path: "/userrecovery",
              meta: {
                has: true,
                path: "YwJmhfys",
              },
              hover: false,
              src: require("../assets/img/icon/business/5.png"),
              active: require("../assets/img/icon/business/5-active.png"),
            },
            {
              id: 26,
              ywid: "",
              title: "低收入群体用水优惠",
              path: "/lowincome",
              meta: {
                has: true,
                path: "YwJmdsrqtysyh",
              },
              hover: false,
              src: require("../assets/img/icon/business/6.png"),
              active: require("../assets/img/icon/business/6-active.png"),
            },
            {
              id: 27,
              ywid: "",
              title: "联系方式变更",
              path: "/numberchange",
              meta: {
                has: true,
                path: "YwJmlxfsbg",
              },
              hover: false,
              src: require("../assets/img/icon/business/7.png"),
              active: require("../assets/img/icon/business/7-active.png"),
            },
            {
              id: 28,
              ywid: "",
              title: "水表验表申请",
              path: "/check",
              meta: {
                has: true,
                path: "YwJmsbybsq",
              },
              hover: false,
              src: require("../assets/img/icon/business/8.png"),
              active: require("../assets/img/icon/business/8-active.png"),
            },
            {
              id: 29,
              ywid: "",
              title: "用水性质变更",
              path: "/naturechange",
              meta: {
                has: true,
                path: "YwJmysxzbg",
              },
              hover: false,
              src: require("../assets/img/icon/business/9.png"),
              active: require("../assets/img/icon/business/9-active.png"),
            },
          ],
        },
        {
          id: 3,
          title: "单位业务",
          children: [
            {
              id: 31,
              title: "暂停用水",
              path: "/comsuspend",
              meta: {
                has: true,
                path: "YwDwztys",
              },
              hover: false,
              src: require("../assets/img/icon/company/1.png"),
              active: require("../assets/img/icon/company/1-active.png"),
            },
            {
              id: 32,
              title: "恢复用水",
              path: "/comrecovery",
              meta: {
                has: true,
                path: "YwDwhfys",
              },
              hover: false,
              src: require("../assets/img/icon/company/2.png"),
              active: require("../assets/img/icon/company/2-active.png"),
            },
            {
              id: 33,
              title: "变更过户",
              path: "/comtransfer",
              meta: {
                has: true,
                path: "YwDwgh",
              },
              hover: false,
              src: require("../assets/img/icon/company/3.png"),
              active: require("../assets/img/icon/company/3-active.png"),
            },
            {
              id: 34,
              title: "信息调整",
              path: "/infochange",
              meta: {
                has: true,
                path: "YwDwXxtz",
              },
              hover: false,
              src: require("../assets/img/icon/company/4.png"),
              active: require("../assets/img/icon/company/4-active.png"),
            },
          ],
        },

        {
          id: 5,
          title: "报事报修",
          children: [
            {
              id: 50,
              title: "网上报修",
              path: "/repair",
              hover: false,
              src: require("../assets/img/icon/report/1.png"),
              active: require("../assets/img/icon/report/1-active.png"),
            },
            {
              id: 51,
              title: "网上投诉",
              path: "/complaint",
              hover: false,
              src: require("../assets/img/icon/report/2.png"),
              active: require("../assets/img/icon/report/2-active.png"),
            },
          ],
        },
      ],
    };
  },
  created() {
    this.IsLogin();
  },
  methods: {
    mouseIn(item) {
      item.hover = true;
      // console.log(item);
    },
    mouseOut(item) {
      item.hover = false;
    },
    //路由跳转
    routerPush(each) {
      if (each.path != "") {
        if (each.meta) {
          GetNotice(each.meta.path).then((res) => {
            if (res.data.data.length > 0) {
              this.$router.push({
                path: "/publicnotice",
                query: {
                  name: each.title,
                  target: each.path,
                  ip: each.meta.path,
                },
              });
            } else {
              this.$router.push(each.path);
            }
          });
        } else {
          this.$router.push(each.path);
        }
      }
    },
    //检验是否登录或登录是否过期
    IsLogin() {
      CheckLogin()
        .then((res) => {
          //console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style lang="less" scoped>
.all {
  width: 1300px;
  min-height: 400px;
  margin: 0 auto;
  // background-color: #fff;
  padding: 20px 0;
  .block {
    width: 100%;
    margin-bottom: 15px;
    .items {
      width: 100%;
      padding: 0 20px;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      .item {
        transition: all 0.3s;
        width: 18%;
        height: 165px;
        background-color: #fff;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        border: 1px solid #e5ecf8;
        border-radius: 10px;
        margin-bottom: 20px;
        margin-left: 25px;
        cursor: pointer;
        img {
          width: 48px;
          height: 48px;
          margin-bottom: 15px;
        }
        p {
          text-align: center;
          font-size: 16px;
        }
      }
      .item:hover {
        transition: all 0.3s;
        // background-color: rgb(56, 50, 50);
        background-color: #bbb;
        color: #ffffff;
      }
    }
  }
}
</style>
